
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M-22.1 119.3c0-14.1 11.4-25.5 25.5-25.5H181c14.1 0 25.5 11.4 25.5 25.5s-11.4 25.5-25.5 25.5H29v304.1h304v-63.3c0-14.1 11.4-25.5 25.5-25.5s25.5 11.4 25.5 25.5v88.8c0 14.1-11.4 25.5-25.5 25.5H3.4c-14.1 0-25.5-11.4-25.5-25.5V119.3z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M476.4 24.8c-33.1-33.1-86.7-33.1-119.8 0l-41.8 41.9L126.4 255c-4.8 4.8-7.5 11.3-7.5 18v104.6c0 14.1 11.4 25.5 25.5 25.5H249c6.8 0 13.3-2.7 18-7.5l230.2-230.2c33.1-33.1 33.1-86.7 0-119.8l-20.8-20.8zm-75.1 164.5l-68.5-68.5L180.6 273l68.5 68.5 152.2-152.2zm-8.6-128.4c13.1-13.2 34.5-13.2 47.6 0l20.9 20.9c13.2 13.2 13.2 34.5 0 47.6l-23.8 23.8-68.5-68.5 23.8-23.8zM187.5 352.1L170 334.6v17.5h17.5z"}})])
          )
        }
      }
    